export type MenuLink = {
  title: string;
  link: string;
  /* Плашка справа от пункта, например 'new' */
  badge?: string;
  /* Логотип вместо текста пункта, имя иконки из my-icon */
  logo?: string;
  /* Открывать в новой вкладке */
  newTab?: boolean;
  /*
    Разрешить пункту перенос на две строки в шапке на узких разрешениях
    (tabletBig, 1024–1379px), где места в ряду мало.
  */
  wrap?: boolean;
};

export type MenuGroup = {
  title: string;
  links: MenuLink[];
};

/* Пункты основной навигации в шапке */
export const HEADER_MENU_ITEMS: MenuLink[] = [
  { title: 'CRE Awards', link: 'https://cre-awards.ru' },
  { title: 'CRE 100', link: 'https://100.cre.ru' },
  { title: 'CRE PRO', link: 'https://pro.cre.ru' },
  { title: 'Мероприятия', link: '/events' },
  { title: 'Журналы', link: '/journal' },
  {
    title: 'Гид «Управление недвижимостью»',
    link: 'https://pm-guide.cre.ru',
    wrap: true,
  },
  { title: 'Новости партнеров', link: '/partners', wrap: true },
  {
    title: '35 лет рынка коммерческой недвижимости России',
    link: 'https://35.cre.ru/?utm_source=topline',
    logo: 'i-cre-35',
    newTab: true,
  },
];

/* Колонки выпадающего меню и футера */
export const MENU_LINKS: MenuGroup[] = [
  {
    title: 'Разделы',
    links: [
      {
        title: 'Новости',
        link: '/news',
      },
      {
        title: 'Аналитика',
        link: '/analytics',
      },
      {
        title: 'Игроки рынка',
        link: 'https://cre.ru/players',
      },
      {
        title: 'Эксперты',
        link: '/expert',
      },
      {
        title: 'Интервью',
        link: 'https://cre.ru/interview',
      },
      {
        title: 'Афиша',
        link: 'https://cre.ru/activity',
      },
      {
        title: 'Мероприятия',
        link: '/events',
      },
      {
        title: 'Журналы',
        link: '/journal',
      },
      {
        title: 'Гид «Управление недвижимостью»',
        link: 'https://pm-guide.cre.ru',
      },
      {
        title: '35 лет рынка коммерческой недвижимости России',
        link: 'https://35.cre.ru/?utm_source=topline',
        logo: 'i-cre-35',
        newTab: true,
      },
    ],
  },
  {
    title: 'Новости',
    links: [
      {
        title: 'Новости партнеров',
        link: '/partners',
      },
      {
        title: 'Проект',
        link: '/category/22',
      },
      {
        title: 'Игроки рынка',
        link: '/category/57',
      },
      {
        title: 'Открытие',
        link: '/category/29',
      },
      {
        title: 'Сделка',
        link: '/category/13',
      },
      {
        title: 'Исследования рынка',
        link: '/category/3',
      },
      {
        title: 'Аукцион',
        link: '/category/26',
      },
      {
        title: 'Назначения',
        link: '/category/7',
      },
      {
        title: 'Экспертный анализ',
        link: '/category/5',
      },
    ],
  },
  {
    title: 'CRE Events',
    links: [
      {
        title: 'Мероприятия',
        link: '/events',
      },
      {
        title: 'Фото',
        link: '/events/photos',
      },
      {
        title: 'Видео',
        link: '/events/videos',
      },
      {
        title: 'График на год',
        link: '/events/schedule',
      },
    ],
  },
  {
    title: 'Журналы',
    links: [
      {
        title: 'CRE',
        link: '/journal/cre',
      },
      {
        title: 'CRE 100',
        link: '/journal/special/cre100',
      },
      {
        title: 'CRE PRO',
        link: '/journal/special/cre-pro',
      },
      {
        title: 'Спецпроекты',
        link: '/journal/special',
      },
      {
        title: 'Гиды',
        link: '/journal/guides',
      },
      {
        title: 'CRE Retail',
        link: '/journal/cre-retail',
      },
      {
        title: 'Реклама',
        link: '/journal/books',
      },
      {
        title: 'Книги',
        link: '/journal/books',
      },
    ],
  },
  {
    title: 'Исследования',
    links: [
      {
        title: 'CRE Awards',
        link: 'https://cre-awards.ru',
      },
      {
        title: 'CRE 100',
        link: 'https://100.cre.ru',
      },
      {
        title: 'CRE PRO',
        link: 'https://pro.cre.ru',
      },
    ],
  },
  {
    title: 'Связаться с нами',
    links: [
      {
        title: 'Реклама на сайте',
        link: '/advertising',
      },
      {
        title: 'Реклама в журналах',
        link: '/advertising_main',
      },
      {
        title: 'Контакты',
        link: '/contacts_main',
      },
    ],
  },
];
